"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceFormatArgsBuilder = void 0;
const retail_price_format_args_1 = require("./retail-price-format-args");
const __1 = require("../..");
class PriceFormatArgsBuilder {
    constructor() {
        this._cxProgram = PriceFormatArgsBuilder.EMPTY_CX_PROGRAM;
    }
    /**
     * Sets the Locale within the {@link PriceFormatArgs} container.
     *
     * @param locale    Locale to be used for the config query.
     *
     * @return builder instance
     */
    withLocale(locale) {
        this._locale = locale;
        return this;
    }
    /**
     * Sets the Currency within the {@link PriceFormatArgs} container.
     *
     * @param currency  Currency to be used for the config query.
     *
     * @return builder instance
     */
    withCurrency(currency) {
        this._currency = currency;
        return this;
    }
    /**
     * Sets the CX-ID within the {@link PriceFormatArgs} container.
     *
     * @param cxId  CX-ID to be used for the config query.
     *
     * @return builder instance
     */
    withCxId(cxId) {
        this._cxId = cxId;
        return this;
    }
    /**
     * Sets the CX-Program within the {@link PriceFormatArgs} container.
     *
     * @param cxProgram  CX-Program to be used for the config query.
     *
     * @return builder instance
     */
    withCxProgram(cxProgram) {
        this._cxProgram = cxProgram;
        return this;
    }
    /**
     * Sets the CX-Family within the {@link PriceFormatArgs} container.
     *
     * @param cxFamily  CX-Family to be used for the config query.
     *
     * @return builder instance
     */
    withCxFamily(cxFamily) {
        this._cxFamily = cxFamily;
        return this;
    }
    /**
     * Sets the Price Format Type within the {@link PriceFormatArgs} container.
     *
     * @param priceFormatType   {@link PriceFormatType} to be used for the config query.
     *
     * @return builder instance
     */
    withPriceFormatType(priceFormatType) {
        this._priceFormatType = priceFormatType;
        return this;
    }
    /**
     * Copies the Arguments from an existing {@link PriceFormatArgs} instance.
     *
     * @param args  {@link PriceFormatArgs} to copy
     *
     * @return builder instance
     */
    fromPriceFormatArgs(arg) {
        return this.withCurrency(arg.currency)
            .withLocale(arg.locale)
            .withCxFamily(arg.cxFamily)
            .withCxId(arg.cxId)
            .withCxProgram(arg.cxProgram)
            .withPriceFormatType(arg.priceFormatType);
    }
    /**
     * Builds a {@link PriceFormatArgs} class type using the previously set
     * properties. The type of the PriceFormatArgs class is defined by the cx family
     *
     * @return {@link PriceFormatArgs} subclass instance by cx-family. If no cx-family is set
     * {@link RetailPriceFormatArgs} will be returned
     */
    build() {
        //if no cx family is passed use retail by default
        if ((0, __1.isNullOrUndefined)(this._cxFamily) || retail_price_format_args_1.RetailPriceFormatArgs.RETAIL_CX_FAMILY === this._cxFamily) {
            return new retail_price_format_args_1.RetailPriceFormatArgs(this._locale, this._currency, this._cxFamily, this._cxId, this._cxProgram, this._priceFormatType);
        }
        else {
            throw new Error(`CX family ${this._cxFamily} is currently not supported.`);
        }
    }
}
exports.PriceFormatArgsBuilder = PriceFormatArgsBuilder;
PriceFormatArgsBuilder.EMPTY_CX_PROGRAM = '[]';
//# sourceMappingURL=price-format-args-builder.js.map